import { 
  collection, addDoc, Timestamp, getDocs, query, orderBy, updateDoc, doc, getDoc
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'solicitudes';

// Tipos de asesoría
export const TIPOS_ASESORIA = {
  COMPRA: 'compra',
  VENTA: 'venta',
  VERIFICACION: 'verificacion',
  TRASPASO: 'traspaso',
  OTRO: 'otro'
};

// Crear una nueva solicitud (público)
export const crearSolicitud = async (solicitudData) => {
  try {
    const dataWithTimestamp = {
      ...solicitudData,
      fechaSolicitud: Timestamp.now(),
      estado: 'pendiente',
      leido: false,
      tipoAsesoria: solicitudData.tipoAsesoria || TIPOS_ASESORIA.COMPRA
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), dataWithTimestamp);
    return { id: docRef.id, ...dataWithTimestamp };
  } catch (error) {
    console.error("Error al crear solicitud:", error);
    throw error;
  }
};

// Obtener todas las solicitudes (solo admin)
export const obtenerSolicitudes = async () => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      orderBy("fechaSolicitud", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaSolicitud: doc.data().fechaSolicitud?.toDate()
    }));
  } catch (error) {
    console.error("Error al obtener solicitudes:", error);
    throw error;
  }
};

// Obtener una solicitud por ID
export const obtenerSolicitudPorId = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        fechaSolicitud: docSnap.data().fechaSolicitud?.toDate()
      };
    }
    return null;
  } catch (error) {
    console.error("Error al obtener solicitud:", error);
    throw error;
  }
};

// Marcar solicitud como leída
export const marcarComoLeida = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { leido: true });
    return true;
  } catch (error) {
    console.error("Error al marcar como leída:", error);
    throw error;
  }
};

// Actualizar estado de solicitud
export const actualizarEstadoSolicitud = async (id, estado) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { estado });
    return true;
  } catch (error) {
    console.error("Error al actualizar estado:", error);
    throw error;
  }
};

// Crear cliente a partir de solicitud
export const crearClienteDesdeSolicitud = async (solicitud) => {
  try {
    const clienteData = {
      nombre: solicitud.nombre,
      documento: solicitud.documento,
      tipoDocumento: 'cc',
      email: solicitud.email,
      telefono: solicitud.telefono,
      direccion: '',
      ciudad: '',
      observaciones: solicitud.mensaje || '',
      fechaRegistro: Timestamp.now(),
      activo: true,
      creadoDesdeSolicitud: true,
      solicitudId: solicitud.id
    };
    
    const docRef = await addDoc(collection(db, 'clientes'), clienteData);
    return { id: docRef.id, ...clienteData };
  } catch (error) {
    console.error("Error al crear cliente desde solicitud:", error);
    throw error;
  }
};

// Obtener estadísticas de solicitudes
export const obtenerEstadisticasSolicitudes = async () => {
  try {
    const solicitudes = await obtenerSolicitudes();
    const pendientes = solicitudes.filter(s => s.estado === 'pendiente').length;
    const noLeidas = solicitudes.filter(s => !s.leido).length;
    const completadas = solicitudes.filter(s => s.estado === 'completado').length;
    
    return {
      total: solicitudes.length,
      pendientes,
      noLeidas,
      completadas
    };
  } catch (error) {
    console.error("Error al obtener estadísticas:", error);
    throw error;
  }
};